var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewer",staticClass:"threeViewer flex-1",class:{ 'bg-white': _vm.bgWhite }})}
var staticRenderFns = []

export { render, staticRenderFns }